import { Sun, Moon, Monitor } from "lucide-react";
import { useTheme, type ThemeMode } from "./theme-provider";
import { cn } from "@/lib/utils";

export function ThemeToggle() {
  const { theme, setTheme } = useTheme();

  const modes: { value: ThemeMode; icon: React.ElementType; label: string }[] = [
    { value: "light", icon: Sun, label: "Light" },
    { value: "dark", icon: Moon, label: "Dark" },
    { value: "system", icon: Monitor, label: "System" },
  ];

  return (
    <div className="flex items-center rounded-lg bg-surface-hover/60 p-0.5">
      {modes.map((m) => (
        <button
          key={m.value}
          onClick={() => setTheme(m.value)}
          className={cn(
            "flex h-7 w-7 items-center justify-center rounded-md text-text-secondary transition-all",
            theme === m.value && "bg-background text-text-primary shadow-sm",
          )}
          aria-label={m.label}
          title={m.label}
        >
          <m.icon size={14} />
        </button>
      ))}
    </div>
  );
}
